import { z } from 'zod';

export const ecosystemIntegratorSchema = z.object({
    ecosystemIntegratorName: z.string().min(1, { message: "Ecosystem Integrator is required" }),
    countryId: z.string().min(1, { message: "Country is required" }).or(z.number()),
    countryCode: z.string().min(1, { message: "County Code is required" }),
    integratorType: z.string().min(1, { message: "Integrator Type is required" }),
    solutionIds: z.array(z.number()).min(1, { message: "Solution is required" }),
    email: z.string()
        .min(1, { message: 'Email is required' })
        .email({ message: 'Invalid email format' }),
    phoneNumber: z
        .string()
        .min(1, { message: "Phone Number is required" })
        .regex(/^\d{10}$/, { message: "Phone Number must be 10 digits" }), 
});
